export enum IdMode {
    Facility = 'fac',
    TIN = 'tin',
}
